import {
  PictureInterface,
  ProductInterface,
} from '../../interfaces/product/product';
import {
  ProductDtoInterface,
  VariantItemDtoInterface,
} from '../../interfaces/product/productDto-interface';
import { ProviderProductDtoClass } from '../provider-product/provider-productDto';
import { Picture, Price, Value } from './product';

export class ProductDtoClass implements ProductDtoInterface {
  Id = '';
  CreatedDate: undefined | Date = undefined;
  UpdatedDate: undefined | Date = undefined;
  Name = '';
  InvoiceName = '';
  Sku = '';
  Barcode = '';
  FilterCode1 = '';
  FilterCode2 = '';
  ShortName = '';
  Description = '';
  Quantity = 0;
  ExpirationDate: undefined | Date = undefined;
  IsVariant = false;
  IsDigital = false;
  IsPackage = false;
  IsActive = true;
  Vat = '20';
  Desi = 0;
  VariantItemPriceType = 0;
  SourceType = 0;
  DontSyncFromOutSource = false;
  LocalNames: any[] = [];
  LocalShortNames: any[] = [];
  LocalDescriptions: any[] = [];
  CategoryId = '';
  CategoryName: any = '';
  BrandId = '';
  BrandName: any = '';
  VariantTemplateId = '';
  VatExemptionCode: any = '';
  Price: Price = new Price();
  Pictures: PictureInterface[] = [];
  VariantItems: VariantItemDtoInterface[] = [];
  PackageItems: any[] = [];
  ProviderProducts: ProviderProductDtoClass[] = [];

  constructor(data: ProductInterface) {
    if (data) {
      this.Id = data.Id;
      this.CreatedDate = data.CreatedDate;
      this.UpdatedDate = data.UpdatedDate;
      this.Name = data.Name;
      this.InvoiceName = data.InvoiceName;
      this.Sku = data.Sku;
      this.Barcode = data.Barcode;
      this.FilterCode1 = data.FilterCode1;
      this.FilterCode2 = data.FilterCode2;
      this.ShortName = data.ShortName;
      this.Description = data.Description;
      this.Quantity = data.Quantity;
      this.ExpirationDate = data?.ExpirationDate;
      this.SourceType = data.SourceType;
      this.IsVariant = data.IsVariant;
      this.IsPackage = data.IsPackage;
      this.IsActive = data.IsActive;
      this.Vat = data.Vat;
      this.Desi = data.Desi;
      this.VariantItemPriceType = data.VariantItemPriceType;

      this.DontSyncFromOutSource = data.DontSyncFromOutSource;
      this.LocalNames = data.LocalNames;
      this.LocalShortNames = data.LocalShortNames;
      this.LocalDescriptions = data.LocalDescriptions;
      this.CategoryId = data.CategoryId;
      this.CategoryName = data.CategoryName;
      this.BrandId = data.BrandId;
      this.BrandName = data.BrandName;
      this.VariantTemplateId = data.VariantTemplateId;
      this.VatExemptionCode = data.VatExemptionCode;
      this.Price = new Price(data.Price);
      this.Pictures =
        data.Pictures?.map((pictureData) => new Picture(pictureData)) ?? [];
      this.VariantItems = data?.VariantItems?.map(
        (variantItemData) => new VariantItemDtoClass(variantItemData)
      )|| [];
      this.PackageItems = data.PackageItems;
      this.ProviderProducts =
        data.ProviderProducts?.map(
          (providerProductData) =>
            new ProviderProductDtoClass(providerProductData)
        ) ?? [];
    }
  }
}

export class VariantItemDtoClass implements VariantItemDtoInterface {
  Id = '';
  Code = '';
  Name = '';
  Barcode = '';
  IncrementType = 0;
  PriceAmount = 0;
  Quantity = 0;
  PictureUrl = '';
  IsActive = true;
  CustomCode: any = '0';
  Values: Value[] = [];
  Pictures: PictureInterface[] = [];

  constructor(data?: any) {
    if (data) {
      this.Id = data.Id;
      this.Code = data.Code;
      this.Name = data.Name;
      this.Barcode = data.Barcode;
      this.IncrementType = data.IncrementType;
      this.PriceAmount = data.PriceAmount;
      this.Quantity = data.Quantity;
      this.PictureUrl = data.PictureUrl;
      this.IsActive = data.IsActive;
      this.CustomCode = data.CustomCode;
      this.Values = data.Values.map((valueData: any) => new Value(valueData));
      this.Pictures = data.Pictures;
    }
  }
}
